/**
 * Helper that takes a query that can be filtered by an id and returns the first result.
 * Useful because most of our endpoints return an array of results,
 * but finding one by id is a common use case.
 */
export const findById = <T>(
  query: (params: { filter: { id: { eq: string } } }) => T[] | null,
  id: string | number,
): T | undefined => {
  const normalizedId =
    typeof id === "string"
      ? id.trim()
      : typeof id === "number" && Number.isInteger(id)
        ? String(id)
        : undefined;

  if (!normalizedId) {
    return undefined;
  }

  return query({
    filter: {
      id: {
        eq: normalizedId,
      },
    },
  })?.[0];
};
